<template>
  <div class="m-12 mt-2 flex flex-col w-auto">
    <div class="w-full flex flex-row justify-between p-4 px-0">
      <breadcrumbs :links="links"></breadcrumbs>
    </div>
    <main class="max-w-lg  mx-auto pt-10 pb-12 lg:pb-16">
      <narrative-settings-form 
      title="Narrative Details"
      description="Let’s get started by filling in the information below to create your new narrative."
      submit-button-text="Create this narrative"
      :loading="loading"
      :username="username"
      :narrative="narrative"
      :isNewNarrative="true"
      @save="createNarrative"
      />
    </main>
  </div>
</template>

<script>
// import Component from "../component_location"
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import NarrativeSettingsForm from '@/views/Narratives/components/NarrativeSettingsForm.vue'
import { EventBus } from "@/utils.js";

export default {
  components: { 
    Breadcrumbs,
    NarrativeSettingsForm
 },

  props: ["username"],

  data() {
    return {
      narrative: {
        name: "",
        description: "",
        privacySetting: "public",
        tags: "story, weather",
      },
      loading: false,
    };
  },

  watch: {},

  methods: {
    narrativeCreated() {
      this.loading = false;
      var narrativeName = this.$store.state.narratives.current.name;
      this.$router.push({
        name: "Narrative",
        params: { username: this.username, narrativeName: narrativeName },
      });
    },

    createNarrative(newNarrative) {
      this.loading = true;
      let details = { username: this.username, narrative: newNarrative };
      this.$store.dispatch("narratives/create", details);
      // this.$samsa
      //   .createNarrative(this.username, this.narrative)
      //   .then((res) => {
      //     this.$store.commit("setNarrative", res.data);
      //     this.$router.push({
      //       name: "Narrative",
      //       params: { username: this.username, narrativeName: res.data.name },
      //     });
      //   })
      //   .catch((err) => {
      //     reportError(err);
      //   });
    },
  },

  computed: {
    links() {
      return [
        {
          name: this.$store.getters['users/nickname'] + "'s narratives",
          route: {
            name: "Narratives",
            params: { username: this.username },
          },
        },
        {
          name: "add narrative",
          route: {
            name: "CreateNarrative",
            params: { username: this.username },
          },
        },
      ];
    },
  },

  mounted() {
    EventBus.$on("narrative-created", this.narrativeCreated);
  },
};
</script>

<style></style>
